import { Modal, Stack } from 'react-bootstrap'
import pdfIcon from '../../../_metronic/images/pdfIcon.png'
import { KTSVG } from '../../../_metronic/helpers'
import { useState } from 'react'
import PdfViewer from '../viewer/PDFViewer'
import closeIcon from '../../../_metronic/images/closeSymbol.svg'
import { GLOBAL_CONSTANTS } from '../../../utils/GlobalConstants'

type imagePreviewProps = {
  url: string
  removeFile?: (name: string) => void
  canRemove: boolean
  className?: string
  width: number
  height: number
}

type pdfPreviewProps = {
  url: string | File
  isViewable: boolean
  removeFile?: (name: string) => void
}

type closeIconWrapperProps = {
  removeFile?: any
  children: any
}
export const CloseIconWrapper = ({ removeFile, children }: closeIconWrapperProps) => (
  <div className='position-relative me-3 mw-150px'>
    <div
      className='position-absolute cursor-pointer'
      style={{ right: 0 }}
      onClick={() => removeFile && removeFile()}
    >
      <svg
        width='12'
        height='12'
        viewBox='0 0 20 20'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g clip-path='url(#clip0_22658_81815)'>
          <path
            opacity='0.5'
            d='M10 8.23254L8.2326 9.99997L0.36628 17.8655C-0.122021 18.3538 -0.122021 19.1455 0.36628 19.6338C0.854542 20.1221 1.64623 20.1221 2.13453 19.6338L10 11.7674L11.7675 9.99997L19.6338 2.13447C20.1221 1.64621 20.122 0.854526 19.6338 0.366225C19.1455 -0.122075 18.3538 -0.122075 17.8655 0.366225L10 8.23254Z'
            fill='currentColor'
          />
          <path
            d='M9.99997 8.23254L11.7674 9.99997L19.6337 17.8655C20.122 18.3538 20.122 19.1455 19.6337 19.6338C19.1455 20.1221 18.3538 20.1221 17.8655 19.6338L9.99997 11.7674L8.23254 9.99997L0.366225 2.13447C-0.122075 1.64621 -0.122036 0.854526 0.366225 0.366225C0.854487 -0.122075 1.64617 -0.122075 2.13447 0.366225L9.99997 8.23254Z'
            fill='currentColor'
          />
        </g>
        <defs>
          <clipPath id='clip0_22658_81815'>
            <rect width='20' height='20' fill='currentColor' />
          </clipPath>
        </defs>
      </svg>
    </div>
    {children}
  </div>
)
export const Filespreview = ({
  uploadedFiles,
  setUploadedFiles,
  removeFile,
}: {
  uploadedFiles: File[]
  setUploadedFiles: React.Dispatch<React.SetStateAction<File[]>>
  removeFile: (file: any) => void
}) => {
  return (
    <Stack direction='horizontal' className='my-5 flex-wrap'>
      {uploadedFiles?.length > 0 &&
        uploadedFiles?.map((file: File, index: number) =>
          file.type.includes('image') ? (
            <ImagePreview
              key={file.name}
              url={URL.createObjectURL(file)}
              removeFile={() => removeFile(file)}
              canRemove={true}
              width={150}
              height={150}
            />
          ) : (
            <PdfPreview
              isViewable={false}
              key={file.name}
              url={file}
              removeFile={() => removeFile(file)}
            />
          )
        )}
      {uploadedFiles.length === 0 && <h4 className='text-muted'>No files selected </h4>}
    </Stack>
  )
}
export const ImagePreview = ({
  url,
  removeFile,
  canRemove = true,
  width,
  height,
  className,
}: imagePreviewProps) =>
  canRemove ? (
    <CloseIconWrapper removeFile={removeFile}>
      <img
        className={`w-${width}px h-${height} mb-2 ${className}`}
        src={url}
        alt='image'
        style={{ objectFit: 'contain' }}
      />
    </CloseIconWrapper>
  ) : (
    <img
      className={`w-${width}px h-${height}px mb-2 ${className}`}
      src={url}
      alt='bill'
      style={{ objectFit: 'contain' }}
    />
  )

export const PdfPreview = ({ url, isViewable, removeFile }: pdfPreviewProps) => {
  const [show, setShow] = useState(false)

  const splittedName = typeof url === "string" ? url?.split('/') : []

  return (
    <CloseIconWrapper removeFile={removeFile}>
      <>
        <img
          className='w-150px h-150px mb-2'
          src={pdfIcon}
          alt='bill'
          style={{ objectFit: 'contain', cursor: `${isViewable ? 'pointer' : "default"}` }}
          onClick={() => {
            isViewable && setShow(true)
          }}
        />
        <h4 className='w-450px fs-7'>
          {typeof url === "string" ? (splittedName[splittedName?.length - 1]) : url.name}
        </h4>
        {isViewable && (
          <Modal
            className='modal fade'
            id='kt_modal_select_location'
            data-backdrop='static'
            tabIndex={-1}
            role='dialog'
            show={show}
            dialogClassName='modal-dialog modal-dialog-centered modal-xl '
            aria-hidden='true'
            onHide={() => setShow(false)}
          >
            <div className='modal-content border border-secondary bg-light'>
              <div className='modal-header bg-secondary bg-gradient'>
                <h5 className='modal-title'>Preview</h5>
                <div
                  className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                  onClick={() => setShow(false)}
                >
                  <img src={closeIcon} className='svg-icon-1' alt='close-icon' />
                </div>
              </div>
              <div className='modal-body'>
                <PdfViewer url={url} previewSettings={GLOBAL_CONSTANTS.previewSettings} type={'contract'} />
              </div>
            </div>
          </Modal>
        )}
      </>
    </CloseIconWrapper>
  )
}
